<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}科室请购</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">请购基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="请购单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成请购单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请购科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择请购科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请购人" prop="applyUserName">
                <el-select :disabled="!editMode" v-model="form.applyUserName" style="width: 90%" filterable placeholder="请选择请购人" :filter-method="getUsersByDept" @change="userChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">请购基础信息</span>
          </div>

          <el-row>
            <!-- <el-col :span="6">
              <el-form-item label="产品来源" prop="assetSource">
                <el-select :disabled="!editMode" v-model="form.assetSource" style="width: 90%" placeholder="请选择产品来源">
                  <el-option v-for="item in DeptApplyBuyOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="资产名称" prop="assetName">
                <!-- <SelectTable v-if="form.assetSource == 0" :disabled="!editMode" :columns="assetColumns" :placeholder="'请选择资产名称'" :innerName="form.assetName" :dataList="assetList" @filterMethod="getFixedAssetList" @change="selectAsset" /> -->
                <el-input :disabled="!editMode" v-model="form.assetName" placeholder="请填写资产名称" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input :disabled="!editMode" v-model="form.specName" placeholder="请填写规格型号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <SelectTree :disabled="!editMode" @handleCheckChange="handleCheckChange" :filterable="true" :filterMethod="getFixedAssetTrees" :defaultProps="defaultProps" :placeholder="'请选择资产类型'" :data="STATIC_FixedAssetTrees" :defaultValue="form.assetTypeName" style="width: 90%"></SelectTree>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlace">
                <el-select :disabled="!editMode" v-model="form.productionPlace" placeholder="请选择产地类型" style="width: 90%">
                  <el-option v-for="item in ProductionPlaceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="申请数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="form.number" :min="1" :controls="false" placeholder="请填写申请数量" style="width: 90%" @change="amountChange"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计单价" prop="price">
                <el-input-number :disabled="!editMode" v-model="form.price" :min="0" :precision="4" :controls="false" placeholder="请填写预计单价" style="width: 90%" @change="amountChange"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预计申请金额单价" prop="amount">
                <el-input-number disabled v-model="form.amount" :min="0" :precision="4" :controls="false" placeholder="系统自动生成申请金额" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="配置要求" prop="require">
                <el-input :disabled="!editMode" v-model="form.require" placeholder="请填写配置要求" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="请购理由" prop="reason">
                <el-input :disabled="!editMode" v-model="form.reason" placeholder="请填写请购理由" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">请购论证</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="" prop="argumentCategory">
                <el-radio-group :disabled="!editMode" v-model="form.argumentCategory" @change="rangeChange">
                  <el-radio v-for="item in DeptApplyBuyRemarkOptions" :label="item.id" :key="item.id">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col v-show="form.argumentCategory == 0" :span="24">
              <el-form-item label="上传附件" prop="fileInfos"> </el-form-item>
              <!-- <my-upload
                  :canEdit="editMode"
                  @filesChange="filesChange"
                  :isLimitMaxSiz="true"
                  :oldList="form.fileInfos"
                ></my-upload> -->
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :showLabel="false" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
            </el-col>
            <el-col v-if="form.argumentCategory == 1" :span="12">
              <el-form-item label="论证内容" prop="argumentContent">
                <el-input :disabled="!editMode" v-model="form.argumentContent" placeholder="请填写论证内容" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="邀请论证参与成员" prop="userIds">
                <div class="select_multiple_value2" v-preventReClick @click="showSelectUserDialog">
                  <!-- <template v-if="form.userInfos && form.userInfos.length > 0"> -->
                  <template v-for="item in form.userInfos">
                    <div :key="item.id" class="value">
                      <span>{{ item.no + " " + item.name + " " }}
                        <i v-if="editMode" class="el-icon-close" style="cursor: pointer" v-preventReClick @click="removeUserItem(item, $event)" />
                      </span>
                    </div>
                  </template>
                  <!-- </template> -->
                </div>
                <select-user :show="showSelectUser && editMode" :oldData="form.userInfos" @getData="getSelectUserData" @close="closeSelectUser"></select-user>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange" :resultName="'论证通过'" :reasonName="'论证意见'"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDeptApplyById,
  SaveDeptApply,
  GetStockByAssetId,
  RejectDeptApply,
} from "@/api";
import {
  DeptApplyBuyOptions,
  ProductionPlaceOptions,
  DeptApplyBuyRemarkOptions,
} from "@/enum";
import MyUpload from "@/components/my-upload";
import SelectTree from "@/components/select-tree";
import SelectUser from "@/components/select-user";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    MyUpload,
    SelectTree,
    SelectUser,
    ApproveInfo,
    UploadFileList,
  },
  data () {
    return {
      form: {},
      DeptApplyBuyOptions: DeptApplyBuyOptions,
      ProductionPlaceOptions: ProductionPlaceOptions,
      DeptApplyBuyRemarkOptions: DeptApplyBuyRemarkOptions,
      rules: {
        applyUserName: [
          { required: true, message: "请购人不能为空", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "请购科室不能为空", trigger: "blur" },
        ],
        assetName: [
          { required: true, message: "资产名称不能为空", trigger: "blur" },
        ],
        assetTypeName: [
          { required: true, message: "资产类型不能为空", trigger: "blur" },
        ],
        productionPlace: [
          { required: true, message: "产地类型不能为空", trigger: "blur" },
        ],
        number: [
          { required: true, message: "申请数量不能为空", trigger: "blur" },
        ],
        price: [
          { required: true, message: "预计单价不能为空", trigger: "blur" },
        ],
        require: [
          { required: true, message: "配置要求不能为空", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "请购理由不能为空", trigger: "blur" },
        ],
        userIds: [
          {
            required: true,
            message: "邀请论证参与成员不能为空",
            trigger: "blur",
          },
        ],
        argumentContent: [
          { required: true, message: "论证内容不能为空", trigger: "blur" },
        ],
        fileInfos: [
          {
            required: true,
            validator: this.fileInfosValidate,
            trigger: "blur",
          },
        ],
      },
      editMode: false,
      assetList: [],
      reject: RejectDeptApply,

      showSelectUser: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getDepts("");
    this.getUsersByDept("");
    this.getFixedAssetTrees("");
    this.getFixedAssetList("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetDeptApplyById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        // if (this.form.assetSource == 0) {
        //   GetStockByAssetId({ id: this.form.assetId })
        //     .then(res => {
        //       if (res.returnData) {
        //         return this.$my_confirm(`当前资产库存为${res.returnData}，是否继续请购该资产？`, '操作提醒', {
        //           type: 'warning'
        //         })
        //           .then(() => {
        //             return SaveDeptApply(this.form)
        //           })
        //       }
        //       else {
        //         return SaveDeptApply(this.form)
        //       }
        //     })
        //     .then(res => {
        //       this.$my_message(`执行成功`,'success');
        //       this.$router.go(-1);
        //     })
        // } else {
        SaveDeptApply(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        // }
      });
    },
    resetForm () {
      this.form = {
        deptId: this.userInfo.deptId,
        deptName: this.userInfo.deptName,
        applyUserId: this.userInfo.id,
        applyUserName: this.userInfo.name,
        remark: "",
        assetSource: 0,
        assetId: "",
        assetName: "",
        specName: "",
        assetTypeId: "",
        assetTypeName: "",
        number: 0,
        price: 0,
        amount: 0,
        productionPlace: 0,
        require: "",
        reason: "",
        fileInfos: [],
        argumentCategory: 0,
        argumentContent: "",
        fileInfos: [],
        userInfos: [],
        userIds: "",
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // change event
    selectAsset (row) {
      this.form.assetId = row.id;
      this.form.assetName = row.name;
      this.form.specName = row.specName;
      this.form.productionPlace = row.productionPlace;
      this.form.assetTypeName = row.assetTypeName;
      this.form.assetTypeId = row.assetTypeId;
      this.form.stockState = row.state;
    },
    deptChange (val) {
      this.form.deptId = val;
      this.form.applyUserId = null;
      this.form.applyUserName = null;
      this.getUsersByDept();
    },
    userChange (val) {
      this.form.applyUserId = val;
    },
    handleCheckChange (node) {
      if (node) {
        this.form.assetTypeId = node.id;
        this.form.assetTypeName = node.name;
      } else {
        this.form.assetTypeId = "";
        this.form.assetTypeName = "";
      }
    },
    amountChange () {
      this.form.amount = this.form.number * this.form.price;
    },
    rangeChange () {
      if (this.form.argumentCategory == 0) {
        this.form.argumentContent = "";
      } else {
        this.form.fileInfos = [];
      }
    },

    getFixedAssetList (keyWord) {
      this.getFixedAssetByQuerys({ keyWord, state: 1 }).then((res) => {
        this.assetList = res;
      });
    },

    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },

    // 人员选择
    showSelectUserDialog () {
      this.showSelectUser = true;
    },
    getSelectUserData (datas) {
      // let ids = data ? data.map(e => e.id) : []
      this.form.userInfos = datas;
      this.form.userIds = this.form.userInfos
        ? this.form.userInfos.map((i) => i.id).join(";")
        : "";
    },
    closeSelectUser () {
      this.showSelectUser = false;
    },
    removeUserItem (item, e) {
      this.form.userInfos = this.form.userInfos.filter((i) => i.id != item.id);
      this.form.userIds = this.form.userInfos
        ? this.form.userInfos.map((i) => i.id).join(";")
        : "";

      e.stopPropagation();
    },

    // validate
    fileInfosValidate (rule, value, callback) {
      if (this.form.argumentCategory == 0 && (!value || value.length == 0)) {
        callback(new Error(`上传附件不能为空`));
      } else {
        callback();
      }
    },
    getUsersByDept (keyWord) {
      this.getDeptUsers(this.form.deptId, keyWord);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
